module.exports = __webpack_public_path__ + "img/bitkeep.0baad5ea.png";